import AgeGroups from './AgeGroups';

export default AgeGroups;
